<template>
  <div>
    <div class="d-flex flex-column flex-md-row my-5 align-center">
      <div class="d-flex flex-column">
        <div class="font-weight-bold">
          Aplicações
        </div>
        <div class="text-body-2 text--secondary mt-1">
          As aplicações são as datas e horários que a avaliação estará disponível para as instituições.<br>
          Só é possível criar uma aplicação se a avaliação estiver <strong>publicada</strong>.
        </div>
      </div>
      <v-spacer />
      <v-btn
        color="primary"
        text
        :disabled="!exam.is_published"
        @click="openNewApplication"
      >
        <v-icon
          small
          left
        >
          mdi-plus
        </v-icon>
        Nova Aplicação
      </v-btn>
    </div>
    <v-simple-table
      v-if="questionsView"
      fixed-header
    >
      <v-progress-linear
        v-if="loading"
        color="amber"
        indeterminate
      />
      <div
        v-else
        class="mr-5 ml-5"
      >
        <v-data-table
          :headers="headers"
          :items="applications"
          :items-per-page="10"
          item-key="id"
          no-data-text="Nenhuma aplicação cadastrada ainda"
        >
          <template #item.institution="{ item }">
            {{ item.institution.id }} - {{ item.institution.name }}
          </template>
          <template #item.updated_at="{ item }">
            {{ returnDate(item.starts_at) }}
          </template>
          <template #item.starts_at="{ item }">
            {{ returnTime(item.starts_at) }}
          </template>
          <template #item.ends_at="{ item }">
            {{ returnTime(item.ends_at) }}
          </template>
          <template #item.status="{ item }">
            {{ item.status }}
          </template>
          <template #item.created_at="{ item }">
            <div class="d-flex flex-row">
              <v-btn
                class="mx-1"
                outlined
                small
                fab
                color="primary"
                :disabled="item.is_finished"
                @click="openEditApplication(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="mx-1"
                outlined
                small
                fab
                color="primary"
                :disabled="item.is_finished"
                @click="deleteApplications(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-simple-table>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import EditApplication from './EditApplication.vue'
import NewApplication from './NewApplication.vue'
import utils from '@/api/utils.js'
import dayjs from '@/dayjs.js'

export default {
  components: {
  },

  mixins: [
    handlesServerValidation
  ],

  props: {
    exam: { type: Object, required: true }
  },

  data () {
    return {
      loading: false,

      applications: [],
      headers: [
        {
          text: 'ID da aplicação',
          align: 'start',
          value: 'id'
        },
        {
          text: 'ID - Escola',
          align: 'start',
          value: 'institution'
        },
        {
          text: 'Data',
          align: 'start',
          value: 'updated_at'
        },
        {
          text: 'Inicio',
          align: 'start',
          value: 'starts_at'
        },
        {
          text: 'Fim',
          align: 'start',
          value: 'ends_at'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'status'
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'created_at'
        }
      ]
    }
  },
  computed: {
    questionsView () {
      return utils.checkPermissions('questions.view-any')
    },
    questionsCreate () {
      return utils.checkPermissions('questions.create')
    },
    questionsUpdate () {
      return !utils.checkPermissions('grade-level-groups.update-any')
    },
    questionsDelete () {
      return !utils.checkPermissions('grade-level-groups.delete')
    }
  },
  watch: {
  },
  async mounted () {
    await this.listApplications()
  },
  methods: {
    async listApplications () {
      this.loading = true
      try {
        this.applications = await this.$api.listApplications(this.exam.id)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar listar Aplicações.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },

    openNewApplication () {
      this.$dialog.custom(NewApplication).with({ idExam: parseInt(this.exam.id) }).show()
        .then(async (application) => {
          if (application) {
            await this.listApplications()
          }
        })
    },

    openEditApplication (item) {
      this.$dialog.custom(EditApplication).with({ application: item }).show()
        .then(async (application) => {
          if (application) {
            await this.listApplications()
          }
        })
    },

    async deleteApplications (application) {
      this.$dialog.confirm('Apagar Aplicação?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          this.loading = true
          try {
            await this.$api.deleteApplications(application.id)
            this.$store.dispatch('setSnackBar', { text: 'Aplicação excluído com sucesso.' })
            await this.listApplications()
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar excluir Aplicação.', color: 'red' })
          } finally {
            this.loading = false
          }
        })
        .show()
    },
    returnDate (data) {
      return dayjs(data).utc(true).format('DD/MM/YYYY')
    },
    returnTime (data) {
      return dayjs(data).utc(true).format('HH:mm')
    },
    dayjs
  }
}
</script>
